<!-- Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. -->

<!--ticket-calendar.component.html-->
<div (click)="openCalendar()" class="date-text">
	{{ dateDisplay$ | async }}
	<span *ngIf="(dateDisplay$ | async) !== ''"
		><mat-icon automationId="expandMore">expand_more</mat-icon></span
	>
</div>
